import { ProdutoProps } from '../types';

export const sortByDesProduto = (array: ProdutoProps[]): ProdutoProps[] =>
  [...array].sort((a, b) => a.des_produto.localeCompare(b.des_produto));
